import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { withContent } from 'components/Content';
import withLanding from 'containers/Landing/withLanding';
import { pages as PAGES } from 'containers/Landing/constants';
import PromotionLandingPage, { CONTENT_KEYS } from './index';

// this is just a temp page we can remove later once ab testing done.
export default compose(
  withLanding(PAGES.promotionLandingPageB),
  withContent(CONTENT_KEYS),
  withRouter,
)(PromotionLandingPage);
